<template>
  <div class="about-page">
    <!-- 顶部截图区：蓝天背景+logo+名称+版本号，白色返回箭头已在图内，仅盖一层透明点击热区 -->
    <div class="about-header">
      <img src="@/assets/icons/about-header.jpg" class="header-img" alt="江苏智慧人社" />
      <div class="back-hit" @click="goBack"></div>
    </div>

    <!-- 版本更新入口 -->
    <div class="hairline"></div>
    <div class="menu-row" @click="checkUpdate">
      <span class="menu-text">版本更新</span>
      <svg viewBox="0 0 24 24" class="menu-arrow">
        <path d="M9 5 L16 12 L9 19" fill="none" stroke="#A09EA5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div class="hairline"></div>

    <!-- 已是最新版本（点击「版本更新」并检测完成后才显示） -->
    <div class="update-btn" v-if="checked">已是最新版本</div>

    <!-- 底部信息 -->
    <div class="about-foot">
      <div class="foot-line">联系电话：<span class="tel">12333</span></div>
      <div class="foot-line">版权所有：江苏省人力资源和社会保障厅</div>
      <div class="foot-line">举办单位：江苏省人力资源和社会保障厅</div>
    </div>
  </div>
</template>

<script>
import { showLoading, hideLoading } from '@/utils/loading'

export default {
  name: 'About',
  data() {
    return {
      // 是否已完成版本检测（控制「已是最新版本」胶囊显示）
      checked: false,
      checking: false
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    // 点击版本更新：先显示1.5s全局loading模拟检测，完成后展示「已是最新版本」
    checkUpdate() {
      if (this.checking) return
      this.checking = true
      showLoading()
      setTimeout(() => {
        hideLoading()
        this.checking = false
        this.checked = true
      }, 1500)
    }
  }
}
</script>

<style scoped>
.about-page {
  min-height: 100%;
  background: #FAFAFA;
  display: flex;
  flex-direction: column;
}
/* 顶部截图（设计稿原图裁切，未自定义背景色） */
.about-header {
  position: relative;
  width: 100%;
  line-height: 0;
}
.header-img {
  display: block;
  width: 100%;
  height: auto;
}
/* 覆盖截图内白色返回箭头的透明热区 */
.back-hit {
  position: absolute;
  left: 0;
  top: 0;
  width: calc(130 * var(--w));
  height: calc(150 * var(--w));
  cursor: pointer;
}
/* 分隔线 */
.hairline {
  height: 1px;
  background: #B4B4BA;
}
/* 版本更新行 */
.menu-row {
  height: calc(150 * var(--w));
  padding: 0 calc(50 * var(--w));
  display: flex;
  align-items: center;
  background: #FAFAFA;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.menu-text {
  flex: 1;
  font-size: calc(46 * var(--w));
  color: #26262B;
}
.menu-arrow {
  width: calc(34 * var(--w));
  height: calc(34 * var(--w));
}
/* 已是最新版本胶囊按钮 */
.update-btn {
  align-self: center;
  margin-top: calc(331 * var(--w));
  width: calc(360 * var(--w));
  height: calc(123 * var(--w));
  border-radius: calc(62 * var(--w));
  background: #666;
  color: #fff;
  font-size: calc(46 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
/* 底部信息 */
.about-foot {
  margin-top: auto;
  padding-bottom: calc(130 * var(--w));
  text-align: center;
}
.foot-line {
  font-size: calc(46 * var(--w));
  color: #252525;
  line-height: calc(95 * var(--w));
}
.tel {
  color: #459DE8;
}
</style>



// WEBPACK FOOTER //
// src/pages/About.vue